import { Box, Flex, ListItem, Stack, UnorderedList } from '@chakra-ui/react';
import { Text } from '@diamond/shared/ui';

import {
  type NlbTermsBlock,
  NLB_TERMS_IMPORTANT_LEFT,
  NLB_TERMS_IMPORTANT_RIGHT,
  NLB_TERMS_INTRO,
  NLB_TERMS_SECTIONS,
} from './nominal-lebih-bayar-terms-sections';

const NLB_TERMS_TEXT_COLOR = '#373f41';
const NLB_TERMS_CALLOUT_COLOR = '#063dc0';
const NLB_TERMS_CALLOUT_BG = '#f1f8ff';

function TermsBlock({ block }: { block: NlbTermsBlock }) {
  if (block.type === 'paragraph') {
    return (
      <Text fontSize="16px" lineHeight="24px" color={NLB_TERMS_TEXT_COLOR}>
        {block.text}
      </Text>
    );
  }

  return (
    <UnorderedList
      spacing={0}
      pl={5}
      fontSize="16px"
      lineHeight="24px"
      color={NLB_TERMS_TEXT_COLOR}
      stylePosition="outside"
    >
      {block.items.map((item) => (
        <ListItem key={item}>{item}</ListItem>
      ))}
    </UnorderedList>
  );
}

function ImportantCalloutColumn({ items }: { items: string[] }) {
  return (
    <UnorderedList
      spacing={0}
      pl={4}
      flex="1"
      minW={0}
      fontSize="14px"
      lineHeight="20px"
      color={NLB_TERMS_CALLOUT_COLOR}
      stylePosition="outside"
    >
      {items.map((item) => (
        <ListItem key={item}>{item}</ListItem>
      ))}
    </UnorderedList>
  );
}

export function NominalLebihBayarTermsContent() {
  return (
    <Stack spacing={6} maxW="896px" w="full">
      <Text
        as="h1"
        fontSize={{ base: '2xl', md: '32px' }}
        fontWeight="medium"
        lineHeight={{ base: '32px', md: '39px' }}
        color={NLB_TERMS_TEXT_COLOR}
      >
        Nominal Lebih Bayar
      </Text>

      <Flex
        align="flex-start"
        gap={{ base: 3, md: 2 }}
        flexWrap="wrap"
        bg={NLB_TERMS_CALLOUT_BG}
        borderRadius="8px"
        px={4}
        py={2}
      >
        <Text
          fontSize="16px"
          fontWeight="medium"
          lineHeight="24px"
          color={NLB_TERMS_CALLOUT_COLOR}
          flexShrink={0}
        >
          Penting:
        </Text>
        <Flex
          flex="1"
          minW={{ base: 'full', md: '200px' }}
          gap={{ base: 0, md: 2 }}
          flexDirection={{ base: 'column', md: 'row' }}
        >
          <ImportantCalloutColumn items={NLB_TERMS_IMPORTANT_LEFT} />
          <ImportantCalloutColumn items={NLB_TERMS_IMPORTANT_RIGHT} />
        </Flex>
      </Flex>

      <Stack spacing={6} color={NLB_TERMS_TEXT_COLOR}>
        <Text fontSize="16px" lineHeight="24px">
          {NLB_TERMS_INTRO}
        </Text>

        {NLB_TERMS_SECTIONS.map((section) => (
          <Box key={section.title}>
            {section.title ? (
              <Text
                as="h2"
                fontSize="16px"
                fontWeight="semibold"
                lineHeight="24px"
                mb={2}
              >
                {section.title}
              </Text>
            ) : null}
            <Stack spacing={2}>
              {section.blocks.map((block, blockIndex) => (
                <TermsBlock
                  key={`${section.title}-${blockIndex}`}
                  block={block}
                />
              ))}
            </Stack>
          </Box>
        ))}
      </Stack>
    </Stack>
  );
}
